// extracted by mini-css-extract-plugin
module.exports = {"ecToggleButtonMap":"ToggleView_ecToggleButtonMap__huV_x","showScale":"ToggleView_showScale__lURw0"};